

// import React, { useState, useEffect, useRef } from "react";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSignOutAlt, faFile } from "@fortawesome/free-solid-svg-icons";
// import { useLanguage } from "../common/LanguageContext";
// import LogOut from "../services/LogOut";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";


// const UserProfileForMSIL = () => {
//   const [showProfileDropdown, setShowProfileDropdown] = useState(false);
//   const [showLogoutDropdown, setShowLogoutDropdown] = useState(false);
//   const [sessionData, setSessionData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const { t } = useTranslation();
//   const navigate = useNavigate();
//   const { language } = useLanguage();
//   const containerRef = useRef(null);

//   // Logout handler
//   const handleLogout = async () => {
//     try {
//       await LogOut.logOutDetails();
//       sessionStorage.removeItem("token");
//       sessionStorage.removeItem("email");
//       localStorage.removeItem("msil_id_token");
//       localStorage.removeItem("msil_access_token");
//       setSessionData(null);
//       navigate("/login");
//     } catch (error) {
//       console.error("Error logging out:", error);
//     }
//   };

//   // Fetch Redis session based on email in IdToken
//   useEffect(() => {
//   const fetchSession = async () => {
//     try {
//       setLoading(true);

//       // Read IdToken from localStorage
//       const idToken = localStorage.getItem("msil_id_token");
//       if (!idToken) {
//         setLoading(false);
//         return;
//       }

//       // Decode token
//       let decoded;
//       try {
//         decoded = jwtDecode(idToken);
//       } catch (err) {
//         console.error("Invalid IdToken:", err);
//         setLoading(false);
//         return;
//       }

//       // Extract email
//       const email =
//         decoded?.email ||
//         decoded?.upn ||
//         decoded?.preferred_username ||
//         "";
//       if (!email) {
//         setLoading(false);
//         return;
//       }

//       const normalizedEmail = email.toLowerCase();
//       sessionStorage.setItem("email", normalizedEmail);

//       // ✅ Immediately set sessionData so UI can display it
//       setSessionData({ email: normalizedEmail });

//       // Call backend API to fetch Redis session
//       const response = await axios.get(
//         `https://massbusinesszone.com/api/auth/session/${normalizedEmail}`
//       );

//       // ✅ Update with enriched session from backend
//       if (response?.data) {
//         setSessionData(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching session:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchSession();
// }, [language]);


//   if (loading) {
//     return <div>Loading user profile...</div>; // Show spinner or message
//   }

//   const displayName = sessionData?.email || "Guest";

//   return (
//     <div
//       className="profile-logout-container"
//       style={{ position: "relative", display: "inline-block" }}
//       ref={containerRef}
//     >
//       <div className="d-flex align-items-center user-profile">
//         <img
//           alt="Profile"
//           className="rounded-circle me-2"
//           height="40"
//           width="40"
//           src="https://storage.googleapis.com/a1aa/image/iuAgSw4j3nBrYUn680q6C5dZXdMQKnkqlWQzX7gmpR8.jpg"
//         />
//         <span className="text-muted d-none d-md-block">
//           {t("welcome")}, <span className="fw-bold">{displayName}</span>
//         </span>

//         {/* Logout Icon */}
//         <div
//           className="ms-2 position-relative"
//           onMouseEnter={() => setShowLogoutDropdown(true)}
//           onMouseLeave={() => setShowLogoutDropdown(false)}
//         >
//           <FontAwesomeIcon
//             icon={faSignOutAlt}
//             size="lg"
//             style={{ cursor: "pointer", color: "#000" }}
//           />
//           {showLogoutDropdown && (
//             <div
//               className="dropdown-menu show position-absolute"
//               style={{
//                 top: "100%",
//                 left: "20px",
//                 transform: "translateX(-80%)",
//                 zIndex: 1000,
//                 boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
//                 borderRadius: "5px",
//                 padding: "5px",
//                 backgroundColor: "white",
//                 width: "120px",
//               }}
//             >
//               <button className="dropdown-item" onClick={handleLogout}>
//                 Logout
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Profile Icon */}
//         <div
//           className="ms-2 position-relative"
//           onMouseEnter={() => setShowProfileDropdown(true)}
//           onMouseLeave={() => setShowProfileDropdown(false)}
//           style={{ width: "24px", height: "24px", cursor: "pointer" }}
//         >
//           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="black">
//             {[...Array(3)].map((_, row) =>
//               [...Array(3)].map((_, col) => (
//                 <circle key={`${row}-${col}`} cx={6 + col * 6} cy={6 + row * 6} r="2" />
//               ))
//             )}
//           </svg>
//           {showProfileDropdown && (
//             <div
//               className="dropdown-menu show position-absolute"
//               style={{
//                 top: "100%",
//                 left: "10px",
//                 transform: "translateX(-90%)",
//                 zIndex: 1000,
//                 boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
//                 borderRadius: "5px",
//                 padding: "5px",
//                 backgroundColor: "white",
//                 width: "150px",
//               }}
//             >
//               <button className="dropdown-item" onClick={() => navigate("/faq")}>
//                 <FontAwesomeIcon icon={faFile} className="mr-2" /> FAQ
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserProfileForMSIL;



import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faFile } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../common/LanguageContext";
import LogOut from "../services/LogOut";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import envProperties from "../../config/envProperties";
import logo from "../assets/marutissymbol.png";
import { toast } from "react-toastify";

const UserProfileForMSIL = () => {
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showLogoutDropdown, setShowLogoutDropdown] = useState(false);
  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(false); // Only for backend fetch

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const containerRef = useRef(null);

  // Logout handler
  const handleLogout = async () => {
    toast.dismiss();
    try {
      console.log("[MSIL Admin] Logging out...");
      await LogOut.logOutDetails();
      console.log("[MSIL Admin] Logout API call completed");
    } catch (err) {
      console.error("Error logging out:", err);
    } finally {
      // Clear all session storage
      sessionStorage.clear();
      
      // Clear all MSIL-related localStorage items
      localStorage.removeItem("msil_id_token");
      localStorage.removeItem("msil_access_token");
      localStorage.removeItem("msil_code_used");
      
      setSessionData(null);
      console.log("[MSIL Admin] All storage cleared, redirecting to login");
      navigate("/login");
      // Toast after navigation so LoginForm's ToastContainer is mounted
      setTimeout(() => {
        toast.success("MSIL Logout Successful", { position: "top-center" });
      }, 100);
    }
  };

  const msilConfig = envProperties?.msil || {};
  const sessionUrl =
    msilConfig.sessionUrl || "https://massbusinesszone.com/api/auth/session";

  // Polling for ADFS token and fetching session
  useEffect(() => {
    let intervalId;

    const fetchSessionData = async () => {
      const idToken = localStorage.getItem("msil_id_token");
      if (!idToken) return;

      clearInterval(intervalId); // Stop polling once token exists

      let decoded;
      try {
        decoded = jwtDecode(idToken);
      } catch (err) {
        console.error("Invalid ADFS token:", err);
        return;
      }

      const email = (decoded?.email || decoded?.upn || decoded?.preferred_username)?.toLowerCase();
      if (!email) return;

      try {
        setLoading(true);

        // Fetch full session from backend
        const response = await axios.get(`${sessionUrl}/${email}`);
        if (response?.data) {
          const backendSession = response.data;
          const role = backendSession.role || "USER";

          // Save email only if not already present
          if (!sessionStorage.getItem("email")) {
            sessionStorage.setItem("email", email);
          }

          // Always update role
          sessionStorage.setItem("role", role);


          // Update sessionData state
          setSessionData({ ...backendSession, email, role });
        }
      } catch (err) {
        console.error("Error fetching session:", err);

      } finally {
        setLoading(false);
      }
    };

    // Poll every 500ms until token exists
    intervalId = setInterval(fetchSessionData, 500);

    return () => clearInterval(intervalId);
  }, [language, sessionUrl]);


  const displayName = sessionData?.name || sessionData?.email;

  return (
    <div
      className="profile-logout-container"
      style={{ position: "relative", display: "inline-block" }}
      ref={containerRef}
    >
      <div className="d-flex align-items-center user-profile">
        {/* Profile Image */}
        <div
          className="rounded-circle me-2 d-flex align-items-center justify-content-center"
          style={{
            height: "40px",
            width: "40px",
            backgroundColor: "white",
            border: "1px solid #ddd",
            overflow: "hidden",
            position: "relative"
          }}
        >
          <img
            alt="Maruti Suzuki Logo"
            src={logo}
            style={{
              height: "26px",
              width: "26px",
              objectFit: "contain",
              display: "block",
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)"
            }}
          />
        </div>

        {/* Welcome message */}
        <span className="text-muted d-none d-md-block">
          {t("welcome")}
          <span className="fw-bold ms-1">{displayName || ""}</span>
          {loading && (
            <span
              className="ms-1 spinner-border spinner-border-sm text-secondary"
              role="status"
              style={{ width: "1rem", height: "1rem" }}
            />
          )}
        </span>

        {/* Logout Icon */}
        <div
          className="ms-2 position-relative"
          onMouseEnter={() => setShowLogoutDropdown(true)}
          onMouseLeave={() => setShowLogoutDropdown(false)}
        >
          <FontAwesomeIcon
            icon={faSignOutAlt}
            size="lg"
            style={{ cursor: "pointer", color: "#000" }}
          />
          {showLogoutDropdown && (
            <div
              className="dropdown-menu show position-absolute"
              style={{
                top: "100%",
                left: "20px",
                transform: "translateX(-80%)",
                zIndex: 1000,
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                borderRadius: "5px",
                padding: "5px",
                backgroundColor: "white",
                width: "120px",
              }}
            >
              <button className="dropdown-item" onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>

        {/* Profile Dots */}
        <div
          className="ms-2 position-relative"
          onMouseEnter={() => setShowProfileDropdown(true)}
          onMouseLeave={() => setShowProfileDropdown(false)}
          style={{ width: "24px", height: "24px", cursor: "pointer" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="black">
            {[...Array(3)].map((_, row) =>
              [...Array(3)].map((_, col) => (
                <circle key={`${row}-${col}`} cx={6 + col * 6} cy={6 + row * 6} r="2" />
              ))
            )}
          </svg>
          {showProfileDropdown && (
            <div
              className="dropdown-menu show position-absolute"
              style={{
                top: "100%",
                left: "10px",
                transform: "translateX(-90%)",
                zIndex: 1000,
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                borderRadius: "5px",
                padding: "0px",
                backgroundColor: "white",
                width: "180px",
              }}
            >
              <button className="dropdown-item" onClick={() => navigate("/faq")}>
                 <FontAwesomeIcon icon={faFile} className="me-2" /> {t("FAQ")}
              </button>
              {sessionStorage.getItem('role') === 'SUPER_ADMIN' && (
                <button className="dropdown-item" onClick={() => navigate("/role-management")}>
                  <FontAwesomeIcon icon={faFile} className="me-2" /> Role Management
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfileForMSIL;
